// import Vue from 'vue'
import { Component } from "vue-property-decorator";
import baseUserContextPage from "./baseUserContextPage";
import { useFaq } from '@/composables';
import { onBeforeMount, getCurrentInstance } from "vue";

@Component({
  setup(props, ctx) {
    const { faqDetail, getFaqById } = useFaq();
    const instance = getCurrentInstance();

    onBeforeMount(() => {
      getFaqById(instance.proxy.$route.params.id)
    })

    return { faqDetail };
  }
})
export default class faqDetailPage extends baseUserContextPage {
  // ...
}
